<template lang="html">
  <div class="">

    <tl-search class="search-width" placeholder="Search Department/Designation/Grades" :value="searchText" />

    <div class="margin-top-33">
      <data-table :columns="policyDataColumnNames" :tableData="policyData" :options="policyData" :checkbox="false" :withForm="false"
      :showedit="false" :showhistory="false" :showdelete="false"/>
    </div>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    name: "policyDocumentsList",
    computed: {
      ...mapState({}),
      ...mapGetters({
        orgid: "onboard/organization/orgid"
      })
    },
    data() {
      return {
        policyDataColumnNames: [
          {
            label: "Name of Document",
            key: "name"
          },
          {
            label: "Document Category",
            key: "documentCategory"
          },
          {
            label: "Tags",
            key: "tags"
          }
        ],
        policyData: [
          {
            id: 1,
            name: "Document 1",
            documentCategory: "Standard of conduct",
            tags: 'HR, Product Manger'
          },
          {
            id: 2,
            name: "Document 1",
            documentCategory: "Standard of conduct",
            tags: 'HR, Product Manger'
          },
          {
            id: 3,
            name: "Document 1",
            documentCategory: "Standard of conduct",
            tags: 'HR, Product Manger'
          },
          {
            id: 4,
            name: "Document 1",
            documentCategory: "Standard of conduct",
            tags: 'HR, Product Manger'
          },
          {
            id: 5,
            name: "Document 1",
            documentCategory: "Standard of conduct",
            tags: 'HR, Product Manger'
          },
        ],
        searchText:"",

      };
    },
    mounted() { },

    methods: {
      ...mapActions({}),

    }
  };
</script>

<style lang="scss" scoped>
  .search-width {
    width: 29.7%;
    height: 35px;
  }

  .margin-top-33{
    margin-top: 33px;
  }

</style>